"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10 4.01a6 6 0 100 12 6 6 0 100-12z"];
//# sourceMappingURL=symbol-circle.js.map